import React from 'react';
import { Link } from 'react-router-dom';
import './styles.scss';

type LeaderboardEntry = {
  userId: string;
  score: number
  User: {
    userName: string;
  }
  League: {
    id: string;
    displayName: string;
  }
}

type LeaderBoardEntriesTableProps = {
  entries: LeaderboardEntry[];
};

const LeaderBoardEntriesTable = ({ entries }: LeaderBoardEntriesTableProps) => (
  <div className="leaderboard-entries-table-wrapper">
    <table className="leaderboard-entries-table">
      <thead>
      <tr>
        <th>User</th>
        <th>Score</th>
        <th>League</th>
      </tr>
      </thead>

      <tbody>
      {
        entries.map((leaderboardEntry, index) => (
          <tr key={index}>
            <td><Link to={`/users/${leaderboardEntry.userId}`}>{leaderboardEntry?.User?.userName}</Link></td>
            <td>{leaderboardEntry?.score}</td>
            <td><Link to={`/leagues/${leaderboardEntry?.League?.id}`}>{leaderboardEntry?.League?.displayName}</Link></td>
          </tr>
        ))
      }
      </tbody>
    </table>
  </div>
);

export default LeaderBoardEntriesTable;
